import { useMemo } from "react";
import LazyLoad from "react-lazyload";
import { Box, Grid, LinearProgress, Skeleton, TablePagination } from "@mui/material";

import { InsightsEmptyState } from "../../components/Insights/InsightsAsyncState";
import { VERIFY_PRICE_PAGE_SIZE_OPTIONS } from "./verifyPriceUtils";
import VerifyPriceCard from "./VerifyPriceCard";

export default function VerifyPriceCardGrid({
  items,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  isRefreshing,
  onCardClick,
  onAccept,
  onReject,
  onRestore,
  actionLoading = false,
  emptyMessage = "No price records for the current filters.",
}) {
  const cardCells = useMemo(
    () =>
      (items || []).map((item) => (
        <Grid key={item.id} item xs={12} sm={6} md={4} lg={3} xl={3}>
          <Box sx={{ height: "100%" }}>
            <LazyLoad height={420} offset={200} once>
              <VerifyPriceCard
                item={item}
                actionLoading={actionLoading}
                onCardClick={onCardClick}
                onAccept={onAccept}
                onReject={onReject}
                onRestore={onRestore}
              />
            </LazyLoad>
          </Box>
        </Grid>
      )),
    [items, actionLoading, onCardClick, onAccept, onReject, onRestore]
  );

  const showLoadingState = isLoading && !items.length;
  const showEmptyState = !showLoadingState && !items.length && totalCount === 0;

  if (showLoadingState) {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: 4 }, (_, index) => (
          <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
            <Skeleton variant="rounded" height={220} sx={{ width: "100%" }} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (showEmptyState) {
    return <InsightsEmptyState message={emptyMessage} />;
  }

  return (
    <Box>
      {isRefreshing ? (
        <LinearProgress sx={{ mb: 1 }} aria-label="Loading price records" />
      ) : null}
      <Grid container spacing={2}>
        {cardCells}
      </Grid>
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={(_, nextPage) => onPageChange(nextPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => onRowsPerPageChange(Number(event.target.value))}
        rowsPerPageOptions={VERIFY_PRICE_PAGE_SIZE_OPTIONS}
      />
    </Box>
  );
}
